import React from 'react';

/**
 * ShowtimeDesktopLayout
 * ---------------------
 * Renders the Showtime page in a desktop 7/5 grid at >=1280px viewports.
 *
 *   ┌──────────────────────────────────────────────────────────┐
 *   │ Header strip (full width)                                │
 *   │ Readiness signal (full width)                            │
 *   │ Show Readiness card (full width)                         │
 *   │ Action buttons (full width, before grid)                 │
 *   ├────────────────────────────┬─────────────────────────────┤
 *   │ MAIN col-span-7            │ SIDEBAR col-span-5          │
 *   │   Run of Show              │   Agreement                 │
 *   │   Tech Rider               │   Key Contacts (4-across)   │
 *   │   Crew Slots               │   Parking & Arrival         │
 *   │                            │   Guest List                │
 *   │                            │   Activity                  │
 *   └────────────────────────────┴─────────────────────────────┘
 *
 * Each prop is a pre-rendered React node owned by the page; this layout
 * only positions them. Pass null for any node that should not render.
 */
export default function ShowtimeDesktopLayout({
  header,
  readinessSignal,
  showReadiness,
  actionButtons,
  runOfShow,
  techRider,
  crewSlots,
  gearOverride,
  agreement,
  keyContacts,
  parking,
  guestList,
  activity,
}) {
  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-6">
      {/* Full-width band: existing header strip + readiness + actions */}
      {header}
      {readinessSignal}
      {showReadiness}
      {actionButtons}

      {/* 7/5 desktop grid */}
      <div className="grid grid-cols-12 gap-6 mt-6" data-testid="showtime-desktop-grid">
        <div className="col-span-7" data-testid="showtime-main-col">
          {runOfShow}
          {techRider}
          {crewSlots}
          {gearOverride}
        </div>
        <div className="col-span-5" data-testid="showtime-sidebar-col">
          {agreement}
          {keyContacts}
          {parking}
          {guestList}
          {activity}
        </div>
      </div>
    </div>
  );
}
